export default {
  methods: {
    calculateTotalWorkerPrice(tw) {
      return (tw.total_units * tw.price) + tw.road_price - tw.prepaid;
    },
    calculateTotalDeltaWithRate(totalDelta, rate) {
      const totalManager = totalDelta * rate / 100;
      return Math.round(totalManager * 100) / 100;
    },
    calculateWorkersPrice(taskWorkers) {
      return taskWorkers
        .map(obj => obj.total_price + obj.prepaid)
        .reduce((acc, current) => acc + current, 0)
    },
    calculateWorkersHours(taskWorkers) {
      return taskWorkers
        .map(obj => obj.total_units)
        .reduce((acc, current) => acc + current, 0)
    },
    calculateWorkersTransfer(taskWorkers) {
      return taskWorkers
        .map(obj => obj.road_price)
        .reduce((acc, current) => acc + current, 0)
    },

    // Подсчёт ЗП менеджеру в зависиммости от ставки в процентах
    calculateTotalDeltaWithRatePercent(totalDelta, rate) {
      const totalManager = totalDelta * rate / 100;
      return Math.round(totalManager * 100) / 100;
    },

    // Подсчёт ЗП менеджеру в зависиммости от ставки в рублях
    calculateTotalDeltaWithRateUnits(totalHours, rate) {
      const totalManager = totalHours * rate;
      return Math.round(totalManager * 100) / 100;
    },
    // Подсчёт Итого с заказчика
    calculateTotalPrice(item) {
      const transfer = this.calculateWorkersTransfer(item.task_workers);

      let totalPrice = item.total_price;

      if (item.payment_first != null) {

        if ((item.payment_second != null) && (item.payment_second > 0) && (item.payment_first_count>0)) {
          let firstCountHours = item.payment_first_count * item.task_workers.length;
          if (firstCountHours > 0) {
            totalPrice = item.payment_first * firstCountHours + (item.payment_second * (item.total_hours-firstCountHours)) + transfer - item.additional_cost + item.additional_income;
          }
        } else {
          totalPrice = (item.payment_first * item.total_hours) + transfer - item.additional_cost + item.additional_income;
        }
      }

      const transferCommission = item.transfer_commission;
      const percentTransfer = transferCommission / 100;
      if (item.payment_type_int === 1) {
        totalPrice = totalPrice + (transfer * percentTransfer);
      } else if (item.payment_type_int === 2) {
        totalPrice = totalPrice + (transfer * percentTransfer);
      } else if (item.payment_type_int === 3) {
        totalPrice = totalPrice + (transfer * percentTransfer);
      }

      return totalPrice;
    },
    // Считаем итоговую дельту
    calculateTotalDelta(item) {
      if ((item.total_price === null) || (item.total_worker_price_with_comiss === null)) {
        return item.total_delta;
      }

      let totalDelta = item.total_delta;

      const totalPrice = item.total_price;
      const totalWorkerPrice = item.total_worker_price_with_comiss;
      const totalHours = item.total_hours;
      const declaratedCost = item.declarated_cost;
      const managementCost = item.management_cost;
      const profitTaxPercent = item.profit_tax;

      const ndsPercent = item.nds;
      const transferCommission = item.transfer_commission;
      const bankCommission = item.bank_commission;
      const ipCommission = item.ip_commission;

      const transfer = this.calculateWorkersTransfer(item.task_workers);

      switch (item.payment_type_int) {
        case 0: // физ лицо
          totalDelta = this.deltaForIndividual(
            totalPrice,
            totalWorkerPrice
          );
          break;
        case 1: // юр лицо
          totalDelta = this.deltaForLegalEntity(
            totalPrice,
            totalWorkerPrice,
            transfer,
            managementCost,
            profitTaxPercent,
            ndsPercent,
            transferCommission
          );
          break;
        case 2: // ИП
          totalDelta = this.deltaForIndividualEntrepreneur(
            totalPrice,
            totalWorkerPrice,
            transfer,
            managementCost,
            profitTaxPercent,
            bankCommission,
            ipCommission,
            ndsPercent,
            transferCommission
          );
          break;
        case 3: // Юр лицо самозанятые
          totalDelta = this.deltaForLegalEntity(
            totalPrice,
            totalWorkerPrice,
            transfer,
            managementCost,
            profitTaxPercent,
            ndsPercent,
            transferCommission
          );
          break;
        default: break;
      }

      // Скидка у заказчика за час
      if (item.customer) {
        if (item.customer.sale > 0) {
          totalDelta = totalDelta - (totalHours * item.customer.sale);
        }
      }

      // Округление
      const totalDeltaRound = Math.round(totalDelta * 100) / 100;

      // Вычитаем расходы
      return totalDeltaRound - declaratedCost;
    },

    // физ лицо
    deltaForIndividual(totalPrice, totalWorkerPrice) {
      return totalPrice - totalWorkerPrice;
    },
    // юр лицо
    deltaForLegalEntity(totalPrice, totalWorkerPrice, transfer, managementCost, profitTaxPercent, ndsPercent, transferCommission) {
      // Комиссия трансфера для ООО 30%
      const percentTransfer = transferCommission / 100;
      const transferCommissionSum = transfer + (transfer * percentTransfer);

      // Трансфер не должен идти в дельту
      let totalDelta = totalPrice - transferCommissionSum;

      // НДС % изменяется в объекте
      const nds = (totalDelta * ndsPercent) / (100 + ndsPercent);
      totalDelta = totalDelta - nds;

      // Налог на прибыль 2%, изменяется в объекте
      let profitTax = 0.0;
      if (profitTaxPercent > 0) {
        const percentProfit = profitTaxPercent / 100;
        profitTax = totalDelta * percentProfit;
      }

      // Управленческие расходы 5%, изменяется в объекте
      let managementTax = 0.0
      if (managementCost > 0) {
        const percent = managementCost / 100;
        managementTax = totalDelta * percent;
      }

      totalDelta = totalDelta - profitTax - managementTax

      totalDelta = totalDelta - (totalWorkerPrice - transfer);

      return totalDelta
    },
    // ИП
    deltaForIndividualEntrepreneur(totalPrice, totalWorkerPrice, transfer, managementCost, profitTaxPercent, bankCommission, ipCommission, ndsPercent, transferCommission) {

      // Комиссия трансфера для ИП 10%
      const percentTransfer = transferCommission / 100;
      const transferCommissionSum = transfer + (transfer * percentTransfer);

      // Трансфер не должен идти в дельту
      let totalDelta = totalPrice - transferCommissionSum;

      // НДС % изменяется в объекте
      const nds = (totalDelta * ndsPercent) / (100 + ndsPercent);
      totalDelta = totalDelta - nds;

      // Комиссия ИП 7%, изменяется в объекте
      let ipCommissionSum = 0.0;
      if (ipCommission > 0) {
        const percentIpCommission = ipCommission / 100;
        ipCommissionSum = totalDelta * percentIpCommission;
      }

      totalDelta = totalDelta - ipCommissionSum;

      // Банковская комиссия 1%, изменяется в объекте
      let bankCommissionSum = 0.0;
      if (bankCommission > 0) {
        const percentBankCommission = bankCommission / 100;
        bankCommissionSum = totalDelta * percentBankCommission;
      }

      // Налог на прибыль 0%, изменяется в объекте
      let profitTax = 0.0;
      if (profitTaxPercent > 0) {
        const percentProfit = profitTaxPercent / 100;
        profitTax = totalDelta * percentProfit;
      }

      // Управленческие расходы
      let managementTax = 0.0
      if (managementCost > 0) {
        const percent = managementCost / 100;
        managementTax = totalDelta * percent;
      }

      totalDelta = totalDelta - bankCommissionSum - profitTax - managementTax;

      return totalDelta - (totalWorkerPrice - transfer);
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Tasks/taskService.js